import React from 'react';
import { observer } from "mobx-react-lite";
import { useTranslation } from 'react-i18next';
import { StringActionDetail } from './components/StringActionDetail';
export const TreeParameterActionAnimationElementValueExtraDetails = observer(({
  valueInstance
}) => {
  const {
    t
  } = useTranslation();
  const selectAnimationInTemplateOption = "shouldSelectAnimationInTemplate";
  const selectAnimationInPlayAnimationActionOption = "shouldSelectAnimationInPlayAnimationAction";
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("select", {
    value: valueInstance.shouldSelectAnimationInTemplate ? selectAnimationInTemplateOption : selectAnimationInPlayAnimationActionOption,
    onChange: ({
      target
    }) => {
      if (target.value === selectAnimationInTemplateOption) {
        valueInstance.setShouldSelectAnimationInTemplate();
      } else {
        valueInstance.setHasRequiredAnimationNames();
      }
    }
  }, /*#__PURE__*/React.createElement("option", {
    value: selectAnimationInTemplateOption
  }, t("action_editor.property_should_select_animation_in_template")), /*#__PURE__*/React.createElement("option", {
    value: selectAnimationInPlayAnimationActionOption
  }, t("action_editor.property_has_required_animations"))), valueInstance.hasRequiredAnimationNames && /*#__PURE__*/React.createElement(StringActionDetail, {
    name: t("action_editor.property_required_animation_sequences"),
    value: valueInstance.requiredAnimationNamesString,
    valueSetter: valueInstance.setRequiredAnimationNamesString.bind(valueInstance),
    allowBlankValue: false
  }));
});